import { flexRender } from '@tanstack/react-table';
import { type LegacyRow } from '@tanstack/react-table/legacy';
import React from 'react';

import { TableCell } from '../table-cell/TableCell';
import { getCellAlignment } from './TableV2';
import { TableColumns, TableData } from './TableV2.types';

type TableRow<T extends string> = Record<T, TableData>;

interface TableV2CellProps<T extends string> {
  row: LegacyRow<TableRow<T>>;
  onRowClick?: (row: LegacyRow<TableRow<T>>) => void;
}

export const TableV2Cell = <T extends string>({
  row,
  onRowClick,
}: TableV2CellProps<T>) => {
  return (
    <tr key={row.id} onClick={onRowClick ? () => onRowClick(row) : undefined}>
      {row.getVisibleCells().map(cell => {
        const meta = cell.column.columnDef.meta as TableColumns | undefined;
        return (
          <TableCell
            key={cell.id}
            alignment={meta?.type && getCellAlignment(meta.type)}
            isNumber={meta?.type !== 'text'}
          >
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </TableCell>
        );
      })}
    </tr>
  );
};
